import { stringify } from 'query-string';
import { template } from 'lodash';
import axios from './client';

const EMAIL_TEMPLATES = '/manage/emails/templates';
const EMAIL_TEMPLATE_TYPES = '/manage/emails/template-types';
const EMAIL_TEMPLATE_TYPES_REMOVE = template('/manage/emails/template-types/<%= id %>');
const EMAIL_TEMPLATE_CATEGORIES = '/manage/emails/template-categories';
const EMAIL_TEMPLATE_UPDATE = template('/manage/emails/templates/<%= id %>');
const EMAIL_UNSUBSCRIBERS = '/manage/emails/unsubscribers';
const EMAIL_UNSUBSCRIBERS_UNSUBSCRIBE = '/manage/emails/unsubscribers/unsubscribe';
const EMAIL_UNSUBSCRIBERS_RESUBSCRIBE = '/manage/emails/unsubscribers/resubscribe';
const EMAIL_TEMPLATES_FREE_USED_FOR = '/manage/emails/free-used-for';


export function getEmailTemplates(params) {
  return axios.get(EMAIL_TEMPLATES, { params });
}

export function getEmailTemplateTypes(params) {
  return axios.get(EMAIL_TEMPLATE_TYPES, { params });
}
export function getEmailTemplateCategories() {
  return axios.get(EMAIL_TEMPLATE_CATEGORIES);
}

export function postEmailTemplateType(params) {
  return axios.post(EMAIL_TEMPLATE_TYPES, stringify(params));
}

export function removeEmailTemplateType(params) {
  return axios.delete(EMAIL_TEMPLATE_TYPES_REMOVE(params));
}

/**
 * Create new email template
 * @param params
 * @returns {Promise<any>}
 */
export function createEmailTemplate(params) {
  return axios.post(EMAIL_TEMPLATES, stringify(params, { arrayFormat: 'bracket' }));
}

/**
 * Edit email template by id
 * @param id
 * @param params
 * @returns {Promise<any>}
 */
export function updateEmailTemplate({ id, ...params }) {
  return axios.post(EMAIL_TEMPLATE_UPDATE({ id }), stringify(params, { arrayFormat: 'bracket' }));
}

export function getFreeUsedFor() {
  return axios.get(EMAIL_TEMPLATES_FREE_USED_FOR);
}

export function getUnsubscribers(params) {
  return axios.get(EMAIL_UNSUBSCRIBERS, { params });
}

export function unsubscribe(params) {
  return axios.post(EMAIL_UNSUBSCRIBERS_UNSUBSCRIBE, stringify(params, { arrayFormat: 'bracket' }));
}

export function resubscribe(params) {
  return axios.post(EMAIL_UNSUBSCRIBERS_RESUBSCRIBE, stringify(params, { arrayFormat: 'bracket' }));
}
